export default "skymp5-front/a0992837692e10783ca95e802b0c888f.mp3";